import { Col, Row } from "antd";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import {
  MdOutlineAccountBalanceWallet,
  MdOutlineCallReceived,
} from "react-icons/md";
import Button from "shared/components/Button";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import Label from "shared/components/Label";
import { NAME_SPACES } from "shared/locales/constants";
import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";

const BankAccount = ({
  values,
  onFileRemove,
  setFieldValue,
  setPercent,
  subscription,
  disabled,
  isFieldRequired,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const TRANSLATION = t("SUBSCRIPTION_AMELLIS.PROOF", {
    returnObjects: true,
  });
  const BLOCK = get(TRANSLATION, "BANK_ACCOUNT");
  return (
    <div className="subscription-form--wrapper">
      <Form type="vertical" title={BLOCK.TITLE}>
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <div className="subscription-form--group-label">
              <Label
                label={BLOCK.FORM.PAYMENT_ACCOUNT}
                icon={<MdOutlineAccountBalanceWallet size={16} />}
                required={
                  !get(disabled, SUBSCRIPTION_FORM_KEYS.PROOF.BANK_ACCOUNT)
                }
                optional={
                  get(disabled, SUBSCRIPTION_FORM_KEYS.PROOF.BANK_ACCOUNT) &&
                  TRANSLATION.OPTIONAL
                }
              />
            </div>
          </Col>
          <Col lg={24} xs={24}>
            <div className="subscription-form--custom-upload">
              <Input
                type="file"
                variant="uploader"
                listType="picture"
                validTypes={TRANSLATION.ALLOWED_FILES_TYPE}
                multiple
                onUpload={(fileList) => {
                  setFieldValue("proof.paymentAccount", fileList);
                  setPercent({
                    ...values,
                    proof: { ...values.proof, paymentAccount: fileList },
                  });
                }}
                onFileRemove={onFileRemove}
                fileList={get(values, "proof.paymentAccount", [])}
              >
                <Row align="center">
                  <Button type="primary--link">
                    {TRANSLATION.ACTIONS.ADD}
                  </Button>
                </Row>
              </Input>
            </div>
          </Col>
        </Row>
        {!get(subscription, "payment.payer.owner.isAdherent") && (
          <Row>
            <Col lg={24} xs={24}>
              <div className="subscription-form--group-label">
                <Label
                  label={BLOCK.FORM.PAYER_ACCOUNT}
                  icon={<MdOutlineCallReceived size={16} />}
                  required={
                    !get(disabled, SUBSCRIPTION_FORM_KEYS.PROOF.BANK_ACCOUNT)
                  }
                  optional={
                    !get(disabled, SUBSCRIPTION_FORM_KEYS.PROOF.BANK_ACCOUNT) &&
                    TRANSLATION.OPTIONAL
                  }
                />
              </div>
            </Col>
            <Col lg={24} xs={24}>
              <div className="subscription-form--custom-upload">
                <Input
                  type="file"
                  variant="uploader"
                  maxCount={1}
                  validTypes={TRANSLATION.ALLOWED_FILES_TYPE}
                  onUpload={(fileList) => {
                    setFieldValue("proof.refundAccount", fileList);
                    setPercent({
                      ...values,
                      proof: { ...values.proof, refundAccount: fileList },
                    });
                  }}
                  onFileRemove={onFileRemove}
                  fileList={get(values, "proof.refundAccount", [])}
                >
                  <Row align="center">
                    <Button type="primary--link">
                      {TRANSLATION.ACTIONS.ADD}
                    </Button>
                  </Row>
                </Input>
              </div>
            </Col>
          </Row>
        )}
      </Form>
    </div>
  );
};

export default BankAccount;
